import { createContext, useContext } from "react";

import { ProductRoomI18nFormModelContext } from "../../_context/context";

import type { ProductRoomI18nFormModelContextType } from "../../_context/context";

export type ProductExistingRoomI18nFormModelContextType = {
	onUpdate: () => void;
} & ProductRoomI18nFormModelContextType;

export const ProductExistingRoomI18nFormModelContext =
	createContext<ProductExistingRoomI18nFormModelContextType | null>(null);

export const ProductExistingRoomI18nFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingRoomI18nFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingRoomI18nFormModelContext.Provider value={value}>
			<ProductRoomI18nFormModelContext.Provider value={value}>
				{children}
			</ProductRoomI18nFormModelContext.Provider>
		</ProductExistingRoomI18nFormModelContext.Provider>
	);
};

export const useProductExistingRoomI18nFormModelContext = () => {
	const context = useContext(ProductExistingRoomI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingRoomI18nFormModelContext must be used within a ProductExistingRoomI18nFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
